import script from "./ClientInfoDataProviderCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientInfoDataProviderCard.vue?vue&type=script&setup=true&lang=ts"

import "./ClientInfoDataProviderCard.vue?vue&type=style&index=0&id=fe871b42&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe871b42"]])

export default __exports__